import { useEffect, useState } from 'react';
import passwordValidation from '../helpers/passwordValidation';

const usePassword = () => {
  const [password2, setPassword2] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState(null);
  useEffect(() => {
    if (password && password2) {
      setErrors(null);
      if (password2 !== password) {
        setErrors('Пароли отличаются');
      } else {
        const errorsArray = passwordValidation
          .filter((rule) => rule.hasError(password, password2))
          .map((rule) => rule.errorText);

        if (errorsArray.length) {
          setErrors('Пароль не подходит: ' + errorsArray.join(', '));
        } else {
          setErrors(null)
        }
      }
    } else setErrors(null);
  }, [password2, password]);

  return [password, setPassword, password2, setPassword2, errors];
};

export default usePassword;
